export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative h-[350px] md:h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Sunlit%20modern%20fulfillment%20center%20interior%20with%20organized%20shelving%20units%20filled%20with%20neatly%20packed%20parcels%20warm%20morning%20light%20streaming%20through%20large%20windows%20creating%20atmospheric%20rays%20clean%20industrial%20aesthetic%20editorial%20documentary%20photography&width=1200&height=900&seq=cta-warehouse-v3&orientation=landscape&nocache=true"
          alt="OOPBUY QC Warehouse"
          title="OOPBUY Spreadsheet Warehouse Qualitätskontrolle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <span className="absolute top-4 left-4 text-xs text-white/80 font-label tracking-wider">
          2025 OOPBUY Guide
        </span>
        <div className="absolute bottom-6 left-6 text-white">
          <h2 className="font-heading text-3xl md:text-5xl font-bold leading-tight">
            Kaufe jetzt<br />
            mit OOPBUY<br />
            Spreadsheet
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center py-14 md:py-20 px-4 md:px-12">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
            Der komplette<br />
            Spreadsheet Guide
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8 leading-relaxed">
            Erfahre alles über den OOPBUY Spreadsheet — von der Einrichtung über QC-Workflows 
            bis hin zum Versand nach Deutschland. Unser Guide erklärt Schritt für Schritt, 
            wie du das Tool optimal für deine Taobao-, Weidian- und Yupoo-Bestellungen nutzt.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/einkaufsfuehrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Einkaufsführer
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white text-sm font-medium rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}